import CryptoJS from 'crypto-js';

/**
 * Produces a deterministic, irreversible HMAC-SHA256 hash of the given text.
 * Used to generate a consistent anonymized identifier (e.g. for LaunchDarkly user keys).
 * Returns an empty string if the input is empty, the secret is missing, or hashing fails.
 */
export async function encryptValue(text: string): Promise<string> {
    const secret = process.env.REACT_APP_SECRET_PASS ?? '';
    if (!text || !secret) return '';
    try {
        return CryptoJS.HmacSHA256(text, secret).toString();
    } catch {
        return '';
    }
}